import { BadgeStyles, BadgeTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Badge } from "./badge.js";
/**
 * The Fabric Badge component.
 *
 * @public
 */
export const definition = Badge.compose({
    name: `${DesignSystem.prefix}-badge`,
    template: BadgeTemplate,
    styles: BadgeStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=badge.definition.js.map